import React, { useEffect, useState, useContext } from "react";
import "../products.css";
import axios from "axios";
import ProductsItem from "../productItem/ProductsItem";
import { Link } from "react-router-dom";
import UserContext from "../../../../context/UserContext";
import { toggleSelectedProduct } from "../../../../context/UserContext";
import ExportApi from "../../../../api/ExportApi";
import { BaseApi } from "../../../../api/BaseApi";
import CustomLoader from "../../../../shared/customLoader";
import ProductsListSkeleton from "../../../../assets/skeleton/productsList";

export default function ProductsList({
  apiEndpoint,
  productType,
  layout = "grid",
  mobileLayout = "grid",
}) {
  const [productsData, setProductsData] = useState([]);
  const [productCheckedState, setProductCheckedState] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const { selectedProducts, setSelectedProducts } = useContext(UserContext);
  const [isCompactLayout, setIsCompactLayout] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false
  );

  if (localStorage.getItem("tokenuser")) {
    var userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
  } else {
    var userId = JSON.parse(localStorage.getItem("admin"))?.id;
  }

  useEffect(() => {
    const handleResize = () =>
      setIsCompactLayout(
        typeof window !== "undefined" ? window.innerWidth <= 1024 : false
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Products API
  useEffect(() => {
    BaseApi.post(apiEndpoint, {
      id: userId,
    })
      .then(function (response) {
        setProductsData(response?.data[productType]?.slice(0, 6));
        setShowLoader(false)
      })
      .catch(function (error) {
        console.log(error);
        setShowLoader(false)
      });
  }, []);

  // Add Products to Compare
  const handleCheckboxChange = (productId) => {
    toggleSelectedProduct(productId, selectedProducts, setSelectedProducts);
  };

  // Remove a Single Product from Compare Section
  const handleRemoveProduct = (productId) => {
    setSelectedProducts((prevSelectedProducts) =>
      prevSelectedProducts.filter((product) => product._id !== productId)
    );

    setProductCheckedState((prevState) => {
      const updatedState = { ...prevState };
      delete updatedState[productId];
      return updatedState;
    });
  };

  // Remove all Products from Compare Section
  const handleClearAll = () => {
    setSelectedProducts([]);
    localStorage.removeItem("Compare");
  };

  const activeLayout = (isCompactLayout ? mobileLayout : layout) || "grid";

  return (
    <div className="deals">
      <div
      style={{ 
        '--bs-gutter-x': '0 !important',
        '--bs-gutter-y': '0 !important'
      }}
        className={`products-list ${
          activeLayout === "carousel" ? "products-carousel" : "row"
        }`}
      >
        {
          showLoader ? (
            <ProductsListSkeleton/>
          ) : !productsData || productsData?.length <= 0 ? (
            <div>
              <h3> No Products Found</h3>
            </div>
          ) : (
            <>
              {
                productsData.map((data) => (
                 <ProductsItem
                    key={data?._id}
                    chipset={data?.chipset}
                    id={data?._id}
                    slug={data?.slug}
                    thumbnail={data?.image}
                    title={data?.title}
                    series={data?.series}
                    brand={data?.brand}
                    price={
                      data.type == 1
                        ? data.new_retail_website_price
                        : data?.lowest_ask > 0
                          ? data?.lowest_ask
                          : "TBD"
                    }
                    model={data?.model}
                    data={data}
                    condition={data?.type}
                    layout={activeLayout}
                    isChecked={productCheckedState[data?._id]}
                    onCheckboxChange={handleCheckboxChange}
                    heighestBid={data?.highest_bid}
                  />
                ))
              }
            </>
          )
        }
    
        {selectedProducts.length > 0 && (
          <div className="selected-products d-flex justify-content-between align-items-center px-lg-5">
            <div className="product-list d-flex w-100">
              {selectedProducts.map((product) => (
                <div key={product?._id} className="bg-light selected-box p-3">
                  <span
                    className="d-flex position-absolute fw-bold"
                    style={{
                      color:
                        product.chipset === "AMD"
                          ? "rgb(186, 0, 21)"
                          : product.chipset === "Nvidia"
                          ? "rgb(114, 179, 0)"
                          : "inherit",
                    }}
                  >
                    {product.chipset}
                  </span>
                  <div className="d-flex mt-2 w-100 gap-2 selected-content">
                    <img
                      src={product?.image[0]}
                      alt="thumbnail"
                      style={{ maxWidth: 80, objectFit: "cover" }}
                    />
                    <div className="product-details d-flex justify-content-between w-100 pt-1 ms-2 ms-md-0">
                      <div className="desc w-100">
                        <p className="text-start mb-0">{product.title}</p>
                        <p className="text-start mb-0 discount fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>
                          {product?.brand}
                        </p>
                        <p className="text-start mb-0 discount fw-bold" style={{ fontSize: '14px', lineHeight: '14px' }}>
                          {product?.series}
                        </p>
                        <p className="text-start mb-0 discount fw-bold" 
                           style={{ 
                              fontWeight: 'normal', 
                              fontSize: '12.6px', 
                              lineHeight: '12.6px', 
                              height: '2.4em', 
                              whiteSpace: 'normal', 
                              overflow: 'hidden', 
                              marginTop: '5px' 
                            }}>
                          {product?.model}
                        </p>
                        <p className="text-start fw-bold mt-2" style={{ color: '#0b4068', fontSize: '12.6px', lineHeight: '12.6px' }}>
                          {product?.condition}
                        </p>
                        <h5 className="text-start fw-bold mt-2">
                          {product?.price}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <button
                    className="close"
                    onClick={() => handleRemoveProduct(product?._id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                    </svg>
                  </button>
                </div>
              ))}
            </div>
            <div className="buttons ps-3">
              <Link to="/compareBuySell">
                <button className="px-4 btn btn-primary">Compare</button>
              </Link>
              <button
                className="px-4 bg-transparent text-blue border-0 btn btn-primary"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
